import React, {useState, useEffect} from 'react';
import axios from 'axios';
import './market.css';
import './ret.css';
import 'boxicons';
import {useSelector, useDispatch} from 'react-redux';
import { isMobile } from 'react-device-detect';
import Modal from 'react-modal';
import {he} from './store';
Modal.setAppElement('#root');

const Nodal = ({isOpen, onClose, onConfirm, message }) => {

    useEffect(()=>{
        if(isOpen){
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = `${scrollbarWidth}px`;
        }else{
            document.body.style.overflow = 'unset';
            document.body.style.paddingRight = '0px';
        };
    
        return () => {
          document.body.style.overflow = 'unset';
          document.body.style.paddingRight = '0px';
        };
      }, [isOpen]);

    if (!isOpen) return null;
  
    return (
      <div className="nodal-overlay" onClick={onClose}>
        <div className="nodal-content" onClick={(e) => e.stopPropagation()}>
          <h3>확인 필요</h3>
          <p>{message}</p>
          <div className="nodal-buttons">
            <button className="cbtn" onClick={onClose}>취소</button>
            <button className="dbtn" onClick={onConfirm}>확인</button>
          </div>
        </div>
      </div>
    );
  };


const Baguo=()=>{
    const [wow, setwow] = useState({});
    const [pwck, setpwck] = useState();
    const [idname, setidname] = useState();
    const [idc, setidc] = useState(false);
    const [pc, setpc] = useState(false);
    const [spin, setspin] = useState(false);
    const [prg, setprg] = useState();
    const [ming, setming] = useState();
    const [kii, setkii] = useState();
    const [mailch, setmailch] = useState(false);
    const [uka, setuka] = useState();
    const furi = useSelector(state=>state.mahena);
    const dispatch = useDispatch();
    const [gmsa, setgmsa] = useState(false);
    const customStyles = {
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
        },
      };

    const jama = async (co)=>{
        co.preventDefault();
        
        if(!pc){
            document.getElementById('toka').innerText="번호 확인 필요";
            return;
        };
        if(!mailch){
            document.getElementById('jni').innerText="메일 확인 필요";
            return;
        }
        const aruki = document.querySelector('input[name="mail"]').value;
    
        if(aruki !== uka){
            document.getElementById('sosok').innerText = "메일 변경 확인 필요";
            return;
        }
        let mingpan;
        if(furi.brand){
            mingpan = furi.brand;
        }else{
            mingpan = false;
        };
        setspin(true);
        const jana = await axios.post('/api/bianjing',{id : co.target.id.value, pw : co.target.pw.value, mail : co.target.mail.value, name : co.target.mingzi.value, brand : mingpan},
        {onUploadProgress : data=>{if(data.total){setprg(Math.round((100*data.loaded)/data.total))}}})
        .then(res=>{setwow(res.data); setspin(false);}).catch(e=>{
            const missy = e.response?.data?.condition;
            if(missy === "rollover"){
                const lawsc = e.response?.data?.missing;
                if(lawsc === "id"){document.getElementById('ida').textContent="ID는 변경할 수 없어요요";} else if(lawsc === "name"){
                    document.getElementById('poku').textContent = "이름을 입력해주세요";
                } else if(lawsc === "pw"){ document.getElementById('toku').textContent = "번호를 입력해주세요";} else if(lawsc ==="mail"){
                    document.getElementById('sosok').textContent = "메일을 입력해주세요";
                }
            }else if(missy === "notpassword"){
                document.getElementById('toku').textContent = "비밀번호는 영문, 숫자, 특수문자 조합의 6자리 이상 10자리 이하입니다";
            }else if(missy === "robber"){
                document.getElementById('ida').textContent = "타인의 정보는 변경할 수 없어요";
            }else if(missy ==="notdone"){ document.querySelector('#jni').textContent = "일시적 오류가 발생했어요"; } else{
                document.querySelector('#jni').textContent = "일시적 오류가 발생했어요";
            };
            setspin(false);});
    };

    const noth = async ()=>{
        //const kake = await axios.get('api/gone').then(dadi=>dadi.data).catch(e=>console.log("zaza"));
        window.open("http://localhost:3001/api/auth/google", "_self"); 
    };

    const jwjw = async ()=>{
        const kake = await axios.post('api/very').then(dadi=>dadi.data).catch(e=>console.log("JWT-auth"));
    };

    if(wow?.id){
        setTimeout(() => {
         window.location.href = "join";}, 2000);
    };

    // const re = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=\[\]{}|]).{6,10}$/;
    const re = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[#?!@$%^&*\- ]).{6,10}$/;
    // const re = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{6,10}$/;
    const pwcheck=(e)=>{
        const ok = re.test(e.target.value);
       
        if(!ok){
            document.getElementById('toku').innerText="영문, 숫자, 특수문자 포함 6자리 이상 10자리 이하입니다.(#?!@$ %^&*-)";
            setpwck();
        }else{
            setpwck(e.target.value);
            document.getElementById('toku').innerText="ok";
        };
    };
    const namecheck=(e)=>{
        const fok = e.target.value;
       
        if(!fok){
            document.getElementById('poku').innerText="수상 이력 확인을 위해 필요합니다";
            setming();
        }else{
            setming(e.target.value);
            document.getElementById('poku').innerText="ok";
        };
    };
    const pwchecka=(e)=>{
        const fok = e.target.value;
        
        if(fok == pwck){
            document.getElementById('toka').innerText="ok";
            setpc(true);
        }else if(!fok){
            document.getElementById('toka').innerText="번호를 입력해주세요";
            setpc(false);
        }else{
            document.getElementById('toka').innerText="번호가 일치하지 않아요";
            setpc(false);
        }
    };
    const ke = /^[가-힣a-zA-Z0-9]{2,10}$/;
    const idcheck= async (e)=>{
        const iddd = e.target.value;
        const okk = ke.test(iddd);
        if(!okk){
            document.getElementById('ida').innerText="한글, 영문, 숫자로 2개 이상 10개 이하 문자로 구성!";
            setidc(false);
        }else{
            const retua = await axios.get(`/api/idcheck/${iddd}`).then(aa=>{return aa.data;}).catch(err=>{return false;});
            if(retua){
                document.getElementById('ida').innerText="ok!";
                setidc(true);
                setidname(iddd);
            }else{
                document.getElementById('ida').innerText="이미 사용 중이네요";
                setidc(false);
            }; 
        };
    };

    let submitop = false;
    const authy= async ()=>{
        const dmal = document.querySelector('input[name="mail"]').value;
        const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const hang = re.test(dmal);
        if(submitop){return;};
        if(kii){return;};
        if(!hang){
            alert("이메일 형식이 맞지 않습니다");
            return;
        };
        submitop = true;
        const sbut = document.querySelector('#canbi');
        sbut.classList.add('dith');
     
        try{
            const dims = await axios.post('/api/gotmail', {mail : dmal});
            setkii(dims.data.condition);
        }catch(err){
            if(err.response.data.condition == "mailaddress"){
                document.getElementById('sosok').textContent = "메일주소 확인이 필요해요";
            };
        }finally{
            submitop = false;
            sbut.classList.remove('dith');
        };
    };

    const matchy= async ()=>{

        const kiib = document.querySelector('input[name="firm"]').value;
        const dmal = document.querySelector('input[name="mail"]').value;
        if(kii !== "prove"){
            document.querySelector('#jni').textContent = "인증 과정이 필요해요"; 
            document.querySelector('#jni').style.fontWeight = "500";
            return;
        };
        try{
            const dims = await axios.post('/api/verifyc', {mail : dmal, code : kiib});
            if(dims.data.condition === "passup"){
                document.querySelector('#jni').textContent = "✅완료!";
                document.querySelector('#jni').style.fontWeight = "500";
                setmailch(true);
                setuka(dmal);
            }
        }catch(err){
            const beens = document.querySelector('#jni');
            const condition = err.response?.data?.condition;
            if(condition === "overtime"){
                beens.textContent = "인증 시간이 만료되었거나 인증 요청 이력이 없습니다";
            } else if (condition === "notsame"){
                beens.textContent = "일치하지 않아요";
            } else if (condition === "serviceout"){
                beens.textContent = "메일로 문의해주세요";
            } else if (condition === "notverify"){
                beens.textContent = "이메일과 인증번호 모두 입력해주세요"
            } else{
                beens.textContent = "일시적인 오류가 발생했습니다"
            };
            beens.style.fontWeight = "500";
            setmailch(false);
        };
    };

    const bye=()=>{
        setgmsa(true);
    };

    const biwoon = async ()=>{

        if (!furi?.id) {
            alert("사용자 정보를 찾을 수 없습니다"); 
            setgmsa(false); 
            return;
          };
        
          try {
            await axios.post('/api/zaijian', { id: furi.id });
            dispatch(he({}));
            setgmsa(false);
            window.location.replace("/");
          } catch (err) {
            const vool = err.response?.data?.condition;
            if(vool === "robber"){
                alert("타인의 정보를 삭제할 수 없습니다");
            };
            setgmsa(false); // 에러 발생 시 닫기
          };
    };

    const cani =()=>{
        setgmsa(false);
    };

    document.title = "정보수정 - 돌파공모"
 
    return(
    <>
    <Modal isOpen={spin} style={customStyles}><progress className="pure-material-progress-circular"/></Modal>
    
    {wow?.id ? <><h2>수정했습니다!! 자기개발에 힘써주세요^^</h2></> :
        <>
        <h2 className='smsm'>회원정보수정{prg}</h2>
        <form className={isMobile ? 'mfamm' : 'famm'} onSubmit={jama}>
        <div className={isMobile ? 'mhoiwon' : 'hoiwon'}>
            <h3><label for="id">아이디</label></h3>
            <span className='j1'>
                <input type='text' name='id' value={furi.id} readOnly/>
            </span>
            <span id="ida"></span>
                    
            <h3><label for="mingzi">이름</label></h3>
            <span className='j1'>
                <input type='text' name='mingzi' value={furi.name} readOnly/>
            </span>
            <span id="poku"></span>

            <h3><label for="pw">비밀번호</label></h3>   
            <span className='j1'>
                <input type='password' name='pw' required  onBlur={pwcheck}/>
            </span>
            <span id='toku'></span>
                    
            <h3><label for="pwcc">비밀번호 재확인</label></h3>   
            <span className='j1'>
                <input type='password' name='pwcc' required  onBlur={pwchecka}/>
            </span>
            <span id='toka'></span>
                    
            <h3><label for="mail">이메일</label></h3>  
            <span className='j1'>
                <input type='email' name='mail' value={furi.mail} pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" title="이메일 형식으로 입력해주세요" required/>
            </span>
            <span id='sosok'></span>
            <span className='balso' id='canbi' onClick={authy} style={{cursor:"pointer"}}>
                인증메일 발송{kii && <span style={{marginLeft:"6px"}}>완료</span>}
            </span>
            <h3><label for="mail">번호입력</label></h3>
            <div style={{width:"100%", margin:"0 auto"}}>
            <span className='jeonson'>
                <input type='text' name='firm'  className='jeoninput'/>
            </span>
            <span>
                <span onClick={matchy} className='jeonha'>확인</span>
                <span id='jni' className='sinho'></span>
            </span>
            </div>
            <button className='gayip' onSubmit={jama}>수정</button>
        </div>
        </form>
        <br/>
        <p>탈퇴를 희망하신다면?</p><span onClick={bye} className='talte'>회원 탈퇴</span>
        </> 
    }
     <Nodal is="rgin" isOpen={gmsa} onClose={cani} onConfirm={biwoon} message="탈퇴하시는 건가요?"/>  
   </>
    );
    }
    
    export default Baguo;